//import React from "react";
import React, { useState, useEffect, useContext } from "react";
// Sections
import TopNavbar from "./../Nav/TopNavbar";
import Header from "./../Sections/Header";
import Pros from "./../Sections/Pros";
import Services from "./../Sections/Services";
import Projects from "./../Sections/Projects";
import ParentReportTemplate from './ParentReportTemplate'
import Blog from "./../Sections/Blog";
import Pricing from "./../Sections/Pricing";
import Contact from "./../Sections/Contact";
import Footer from "./../Sections/Footer";
//CarouselLanding
//CarouselX
import CarouselX from "./../Sections/CarouselX";
import CarouselLanding from "./../Sections/CarouselLanding";

import { useSearchParams } from 'react-router-dom';

import axios from "axios";
import { Input, Stack, Box, Typography, useTheme, Button, styled, IconButton} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import {Badge, theme} from "@material-ui/core";
import Select from "react-select";


import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

import PhoneIcon from '@mui/icons-material/Phone';
import PasswordIcon from '@mui/icons-material/Password';
import LoginIcon from '@mui/icons-material/Login';
import LockIcon from '@mui/icons-material/Lock';

import SearchIcon from "@mui/icons-material/Search";

import urls from './../constants/urls';
import { ColorModeContext, tokens } from "./../theme";
import Servx from "../Sections/Servx";

import ReportToParentTemplate from './../scenes/form/ReportToParentTemplate';

const TXTRoundedDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    //height: "100%",
    marginTop: "10px",
    marginBottom: "20px",
    marginLeft: "10px",

}));


const HeightSpaceDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    //border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    height: "100px",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));




const HeightSpaceDivEXT= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    height: "300px",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));


const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"

});

const StyledSelect= styled(Select)({
    fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});



export default function LandingPage({ sendDataToParent }) {

  
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  
  const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
  
  const [listStatus, setListStatus]=useState(false);

  const [searchParams, setSearchParams]=useSearchParams();
  const stestr = searchParams.get('ste');
  
  const [reportData, setReportData]=useState([]);
  //alert(stestr);
  const [ formData, setFormData]= useState({
            ward: 0,
            name: '',
            status: 'Active',
            school_code: '123',
            street: '',
            plot_number: '',
            area_details: '',
            telephone_number_1: '',
            telephone_number_2: '',
            email: '',
            website: '',
      })
  
  const [formDataUserLoginEXT, setFormDataUserLoginEXT]=useState({
       
        users_id: 0,// = models.BigAutoField(primary_key=True)
        first_name: 'Default',// = models.CharField(max_length=32)
        middle_name: 'Default',// = models.CharField(max_length=32)
        last_name: 'Default',// = models.CharField(max_length=32)
        full_name: 'Default',// = models.CharField(max_length=64)
        gender: 'Default',// = models.CharField(max_length=16)
        mobile_number: '',// = models.CharField(max_length=16)
        user_email: 'Default',// = models.CharField(max_length=32)
        date_of_birth: '1980-01-01 00:00:00.000',// =models.DateTimeField(max_length=32, null=True)
        password_id: 0,// = models.IntegerField()
        user_password: '',// =models.CharField(max_length=128)
        login_category_id: 0,// = models.IntegerField()
        login_category_name: 'Default',// =models.CharField(max_length=32)
    })
  
  const [errors, setErrors]=useState({});


  const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
    }
    };


 const handleChangeInput = (e) =>{
   const {name, value } =e.target
   setFormDataUserLoginEXT({
    ...formDataUserLoginEXT,
    [name]: value
   })
   //
   
   //
   setErrors({});
 }

 
  
 
   

  const handleButtonSubmit = () =>{
    
   console.log("formDataUserLoginEXT.mobile_number=" + formDataUserLoginEXT['mobile_number'])
   console.log("formDataUserLoginEXT.user_password=" + formDataUserLoginEXT['user_password'])
    
    let newErrors=validateForm(formDataUserLoginEXT);
    setErrors(newErrors);
    
    console.log("errors.lenght=" + Object.keys(newErrors).length)
    if(Object.keys(newErrors).length===0){
      console.log("len0")
      Login()
    }
    else{
      console.log("len1")
    }
    /***
    
    ***/

}


    
const validateForm = (data) =>{
  const errors={};
  if(data.mobile_number==="" || data.mobile_number==""){
    console.log("if " + ", data.name=" + data.mobile_number)
    errors.mobile_number='Please enter mobile number';
   }
   else{
    console.log("else " + ", data.mobile_number=" + data.mobile_number)
   }

   if(data.user_password==="" || data.user_password==""){
    console.log("if " + ", data.name=" + data.user_password)
    errors.user_password='Please enter password';
   }
   else{
    console.log("else " + ", data.user_password=" + data.user_password)
   }
  
  return errors;

}

   
  
    
        
    

   const Login=()=>{
     
     
    //let url = API_URL;
    let APIURL= APIROOTURL + "UserLoginViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formDataUserLoginEXT, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data.msg=" + res.data.msg)
        let usersId=res.data.usersId;
       let fullName=res.data.username; //res.data.fullName;
       
       console.log("res.data.fullName=" + res.data.fullName)
       // schoolDetails
       
       let schoolDetails=res.data.schoolDetails;
       
       console.log("res.data.schoolDetails.fullName=" + res.data.schoolDetails.schoolName)
       
       console.log("res.data.schoolDetails['schoolName']=" + res.data.schoolDetails['schoolName'])

       //let loginCategoryName=res.data.category;
       let loginCategoryName=res.data.loginCategoryName;
       let userRolesList=[];//res.data.qr;
      
       let loginDetails=res.data.loginDetails;
       
       let loginDetailsForm={
        loginCategory: loginCategoryName, 
        userPassword: formDataUserLoginEXT['user_password'],
        fullName: fullName,
        usersId: usersId,
      }
      
      //alert(res.data.msg);

      if (res.data.msg==="User login was successful"){
        //alert("res.data.details.loginCategory=" + res.data.details.loginCategory); 
        sendDataToParent(true, usersId, fullName, loginCategoryName, userRolesList, loginDetailsForm, schoolDetails, loginDetails);
           
       }
       else{
        alert("Login failed");
       }
       //

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));

   }   



   const [formLoginDetails, setFormLoginDetails]=useState({
    loginCategory: '',
    mobileNo: '',
    userPassword: '',
    fullName: '',
    userId: 0,
  })

  const userLogin=()=>{
      
      //
      let userName=formDataUserLoginEXT['username'];
      let userPasscode=formDataUserLoginEXT['passcode'];

      if(userName==="" || userName===NaN || userName===undefined){
          alert("Enter username");
          return;
      }

      if(userPasscode==="" || userPasscode===NaN || userPasscode===undefined){
          alert("Enter user passcode");
          return;
      }
     
      let url=APIROOTURL + "/restaurant/TryLoginPasscodeViewEXT";
      axios
    .post(url, formDataUserLoginEXT, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log("res.data=" + res.data);
      console.log("res.data.msg=" + res.data.msg);
      //console.log("res.data.qr=" + res.data.qr);
      
     let usersId=res.data.usersId;
     let fullName=res.data.username; //res.data.fullName;
     
     let loginCategoryName=res.data.category;
     let userRolesList=[];

     let loginDetails=[];
     
     //

     let loginDetailsForm={
      loginCategory: loginCategoryName,
      
      userPassword: userPasscode,
      fullName: fullName,
      usersId: usersId,
    }
      
     if (res.data.msg==="Login was successful"){
      //loadUserRoles=(true, usersId, fullName, loginCategoryName)
      
      sendDataToParent(true, usersId, fullName, loginCategoryName, userRolesList, loginDetailsForm);
        
     }
     else{
      alert("Login failed");
     }
     //
    })
    .finally(() => {
      
    })
    .catch((err) =>{
      console.log("error 343QWE908 : " + err)
      
      if(err.includes("AxiosError: Request failed with status code 500")){
        alert("Failed to connect to server, error 500")
      } 
      else if(err.includes("AxiosError")){
         alert("Failed to connect to server")
      }
      else{

      }

    });
  
  console.log(" QWE132 url=" + url);

  }
  

  
   useEffect(()=>{
      //alert(schoolIdGlobal + "," + usersId)
      //alert(stestr)
      let APIURL= APIROOTURL + "ParentReportForSingleStudentFullExamResultsViewEXT/" + stestr
      console.log(APIURL);

  let headerOptions={
      method: 'GET',
  }
  
  fetch(APIURL, headerOptions)
  .then( response => response.json())
  .then( json =>{
   console.log("json 123 =" + json);
   //console.log("json 5123 =" + json[0]['name']);
   //console.log("json 123 =" + json[0].name);
   let newList=[];
   
   {/*** *
   {
    json.map(function(dt, index){
     
      newList.push(
        //yamal
        
        {
          id: dt.id, 
          subject: dt.subject,
          score: dt.score,
          grade: dt.grade,
          remarks: dt.remarks,
          divisionPoints: dt.divisionPoints,
          gpaPoints: dt.gpaPoints,
          position: dt.position
        }
      )
      console.log("grade=" + dt.grade)
    })
  }
   ***/}  
  //alert(newList.length);

  //setReportData(newList);
  //alert("l=" + json.data.length);
  if (json.data.length == 0) {
    
    setListStatus(false);
  } else {
   // alert("newList.length =" + newList.length);
    setListStatus(true);
  }
  
   //loadExamSubClass(json)
  })
  .catch(error=> console.log("error=" + error))
   

    },[stestr])

  return (
    <>
    { listStatus?(
    <>
    <ParentReportTemplate schoolStudentsScoresEXT={reportData} />
    </>
    ):
    (
      <>
      <TopNavbar sendDataToParent={sendDataToParent} />

      <CarouselX />
      <Servx />
      {/***<Header />***/}
      
      {/***<Pros />***/}
      <Servx />
      {/***<Services />***/}
      
      <Projects />
      <Blog />
      <Pricing />
      <Contact />
      <Footer />
      </>
    )
     }
    </>
  );
}


